module.exports = "https://r.nearpod.com/assets/media/image/notification_preferences_icon-29a9c6fc2ebe1d598a3b8860afe7ee8a.svg";